import { Upload } from 'antd';
import type { DraggerProps } from 'antd/lib/upload';
import styled, { css } from 'styled-components';

const { Dragger } = Upload;

export const StyledDropzone = styled(Dragger)<DraggerProps>`
  &&&.ant-upload-drag {
    height: min-content;
    min-width: 200px;
    ${({ disabled }) =>
      !disabled &&
      css`
        :hover {
          background: ${({ theme }) => theme.color.semantic.primary.background.hoverWeak};
          border: 1px solid ${({ theme }) => theme.color.core.gray.main[400]};
        }
      `}
    ${({ disabled }) =>
      disabled &&
      css`
        border: none;
        background: ${({ theme }) => theme.color.core.white};
      `};
  }
`;

// wrapper so we are able to style file list of Upload from antd
export const UploadWrapper = styled.div`
  margin-bottom: 4px;

  .ant-upload-list::before {
    content: none;
  }
  .ant-upload-list.ant-upload-list-picture-card {
    margin-top: 5px;
    display: grid;
    grid-gap: 5px;
    grid-template-columns: repeat(2, 1fr);
    justify-content: start;

    @media (min-width: 780px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1280px) {
      grid-template-columns: repeat(4, 1fr);
    }

    .ant-upload-list-picture-card-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      margin: 0;
    }
  }

  .ant-upload-list {
    max-height: 25vh;
    overflow-y: auto;
  }

  & ::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
`;

export const StyledDropzoneListItem = styled.div`
  ${({ theme }) => css`
    a {
      color: ${theme.color.semantic.link.default};
    }

    .anticon-delete {
      color: ${theme.color.semantic.feedback.type.error} !important;
    }
  `};
`;
